import React, { FC } from "react";

import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

type Props = { className?: string };

export const Open: FC<SvgIconProps & Props> = props => {
    return (
        <SvgIcon {...props} variant={"stroke"}>
            <path
                d="M19.0001 11V5M19.0001 5L13.0001 5M19.0001 5L11 13"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M10 8H5V19H16V14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
};
